import { createLazyFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/admin/routes/Settings";

export const Route = createLazyFileRoute("/_auth/admin/settings/")({
  component: SettingsPage,
});
